import { EventRouter } from '@deqo/podopolis';
import { injectable } from 'inversify';
import { Point } from '../../../../platform/geom/Point';

@injectable()
export class ShittyClientRelay extends EventRouter<{ offset: [string, Point] }> {
}
